module.exports = "../fonts/hotel_check-in_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hotel_check-in_icon.svg
// module id = 434
// module chunks = 0